import {lazy, Suspense} from 'react'

import type {NavigationTabPopoverProps} from './NavigationTabPopover'

const NavigationTabPopover = lazy(async () => {
  const module = await import('./NavigationTabPopover')
  return {default: module.NavigationTabPopover}
})

export function LazyNavigationTabPopover(props: NavigationTabPopoverProps) {
  return (
    <Suspense fallback={null}>
      <NavigationTabPopover {...props} />
    </Suspense>
  )
}
